import React, { useCallback } from 'react';
import { useDropzone } from "react-dropzone";
import styled from 'styled-components';
import { Form } from 'react-bootstrap';
import { Controller } from "react-hook-form";
import { Colors } from '../colors/colors';
import { Icons } from '../../hooks/useIcons';






export default function DragAndDrop({
  handleDragDrop,
  fileName,
  label,
  errorText,
  required,
  placeholder,
  name,
  type,
  cName,
  id,
  onChange,
  style,
  value,
  hasLabel,
  control,
  multiple,
  ...rest
}) {


  const {
    secondaryColor,
  } = Colors();

  const {
    uploadIcon
  } = Icons();

  const onDrop = useCallback(
    (acceptedFiles) => handleDragDrop(acceptedFiles),
    [handleDragDrop]
  );



  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    onDrop,
    multiple,
    ...rest,
    accept: {
      "image/png": [".png", ".jpg"],
      "image/jpeg": [".jpeg", ".png"],
      "video/mp4": [".mp4", ".wmv"],
      "application/pdf": [".pdf"],
      "application/msword": [".doc"],
      "application/csv": [".csv"],
    },
  });


  return (

    <>
      <Form.Label
        style={{
          margin: "8px auto",
        }}
      >
        <span>
          {label}
        </span> {" "}
        {required ? (
          <span className="required">{"*"}</span>
        )
          :
          (<>
            <span className="i">{""}</span>
          </>)
        }
      </Form.Label>

      <Controller
        name={name}
        defaultValue={value}
        control={control}
        render={({ field: { onChange } }) => (
          <div
            {...getRootProps()}>
            <input
              {...getInputProps({})}
            />
            <div
              className="form-control"
              style={{
                height: "300px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                gap: "2rem",
                padding: "1rem",
                cursor: "pointer",
                border: `3px dashed ${isDragAccept
                  ? "green"
                  : isDragReject
                    ? "red"
                    : errorText
                      ? "red"
                      : "#ccc"
                  }`
              }}
            >

              <ImageWrapper>
                <Img
                  src={uploadIcon}
                  alt="Upload"
                />
              </ImageWrapper>

              {!isDragActive && !fileName && <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <div>
                  {placeholder ? placeholder : "Drag and drop your files here"}{" "}
                </div>

                or

                <div

                  style={{
                    color: secondaryColor
                  }}>
                  Browse Files{" "}
                </div>
              </div>}


              {isDragActive ?
                (<div>
                  Drop your files here{" "}
                </div>)
                :
                (<div>
                  {fileName && fileName?.trim() && fileName}
                </div>)
              }
            </div>
          </div>

        )}
      />

      {errorText && (
        <p className="errorMsg">{errorText}</p>
      )}

    </>
  )
}


const ImageWrapper = styled.div`
  height: 24px;
  width: 24px;
  margin: "1rem auto",
`;

const Img = styled.img`
  height: 100%;
  width: 100%;
`;